__turbopack_context__.v({
  "backgroundImageAndGradients": "TopArtistSection-module___dImHG__backgroundImageAndGradients",
  "container": "TopArtistSection-module___dImHG__container",
  "content": "TopArtistSection-module___dImHG__content",
  "styledButton": "TopArtistSection-module___dImHG__styledButton",
  "subTitle": "TopArtistSection-module___dImHG__subTitle",
  "title": "TopArtistSection-module___dImHG__title",
});
